import getRollbackErrorTracking from "@custom/rtk-apis/analytics/getRollbackErrorTracking";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getRollbackErrorTrackingSlice = createSlice({
  name: "getRollbackErrorTrackingSlice",
  initialState,
  reducers: {
    clearRollbackErrorTracking: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRollbackErrorTracking.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRollbackErrorTracking.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload;
        state.msg = payload.message;
      })
      .addCase(getRollbackErrorTracking.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getRollbackErrorTrackingSlice.reducer;
export const { clearRollbackErrorTracking } = getRollbackErrorTrackingSlice.actions;
